<div class="modal-content">
  <div class="div-message-box animated fadeIn fast">
    <div class="message-box-container animated fadeIn fast">
      <div class="message-box-middle">

        @if (!enableButton) {
<div class="loading-section">
          <i class="fa fa-spinner fa-spin"></i>
          <span class="loading-text">Processing...</span>
        </div>
}

        @if (enableButton) {
<div>
          <span class="msg-title">
            <i class="fa fa-sign-out txt-color-orangeDark"></i>Confirm
          </span>
          <p class="p-text">Are you sure you want to delete this override?</p>

          <div class="message-box-button-section">
            <button class="btn btn-default btn-xs"
                    (click)="cancel()"
                    [disabled]="!enableButton">
              Cancel
            </button>
            <button class="btn btn-danger btn-xs"
                    (click)="save()"
                    [disabled]="!enableButton">
              Yes
            </button>
          </div>
        </div>
}

      </div>
    </div>
  </div>
</div>
